import React from 'react'
import { Link } from 'react-router-dom';

function NavBar() {
    //let navigate = useNavigate();

    return (
        <nav class="navbar navbar-expand-lg navbar-dark bg-success">
            <Link class="navbar-brand" to="/">Morton Arboretum</Link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
            <li class="nav-item active">
            <Link class="nav-link" to="/">Data Form</Link>
            </li>
            <li class="nav-item active">
                <Link class="nav-link" to="/MasterForm">Master Form</Link>
            </li>

            <li class="nav-item active">
                <Link class="nav-link" to="/CreateNewUser">Create New User</Link>
            </li>

            <li class="nav-item active">
                <Link class="nav-link" to="/TreesObserveredMap">Observed Trees Map</Link>
            </li>

            <li class="nav-item active">
                <Link class="nav-link" to="/ObservationHeatMap">Observation Heat Map</Link>
            </li>

            </ul>

        </div>
        </nav>
    )
}

export default NavBar;